const IGLink = ({ word }) => {
    return (
        <a href="https://instagram.com/oliverbryann" target="_blank" rel="noreferrer" className="embeddedLink">
            {word}
        </a>
    );
};

export default IGLink;
